import React from 'react';
import {
  Box,
  Flex,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from '@chakra-ui/react';
import Sidebar from './Sidebar';
import ChatBox from './ChatBox.js';
import Dashboard from './Dashboard';
import Settings from './Settings';
import { useUIStore } from '../store/uiStore';
import { useVehicleStore } from '../store/vehicleStore';
import { useChatStore } from '../store/chatStore';

const MainLayout = ({
  isMobile,
  showSidebar,
  showDrawer,
  isOpen,
  onClose,
  isSettingsView,
  isChatView,
  onChatSubmit,
  onSettingsClick,
  onVehicleSelect,
  onBackToSettings,
  onClearChat,
  onProcessManagement,
  messagesLoading,
}) => {
  // Zustand stores
  const { chatMessages } = useChatStore();
  const { selectedVehicleConversationId, selectedVehicle, vehicleContext } = useVehicleStore();
  const { inputValue, setInputValue, setIsChatView, isLoading } = useChatStore();
  
  return (
    <Flex>
      {/* Sidebar */}
      <Sidebar 
        isOpen={showSidebar} 
        isMobile={isMobile} 
        onSettingsClick={onSettingsClick}
        onVehicleSelect={onVehicleSelect}
        onClearChat={onClearChat}
        onCloseSidebar={isMobile ? onClose : undefined}
      />

      {/* Main Content */}
      <Box flex={1} overflow="hidden">
        {isSettingsView ? (
          <Settings onBack={onBackToSettings} />
        ) : isChatView ? (
          <ChatBox 
            isMobile={isMobile} 
            chatMessages={chatMessages} 
            onChatSubmit={onChatSubmit} 
            conversationId={selectedVehicleConversationId}
            onProcessManagement={onProcessManagement}
            selectedVehicle={selectedVehicle}
            vehicleContext={vehicleContext}
            messagesLoading={messagesLoading}
          />
        ) : (
          <Dashboard 
            onChatSubmit={onChatSubmit}
          />
        )}
      </Box>

      {/* Mobile Drawer */}
      <Drawer isOpen={showDrawer} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent maxW="70%">
          <DrawerCloseButton />
          <Sidebar 
            isOpen={true} 
            isMobile={true} 
            onSettingsClick={onSettingsClick}
            onVehicleSelect={onVehicleSelect}
            onClearChat={onClearChat}
            onCloseSidebar={onClose}
          />
        </DrawerContent>
      </Drawer>
    </Flex>
  );
};

export default MainLayout; 